import React, {useState} from 'react';
import './ContractMain.css'; // Assuming you save the CSS in Agreement.css
import razitko from '../../../img/razitko.png'
import Button from 'react-bootstrap/Button';
import './ContractMain.css'
import fetchData from '../../../function/fetchData'
import SignatureColumn from './SignatureColumn';
import Spinner from 'react-bootstrap/Spinner';


const ContractMain = ({server, token, data, tokenOfContract, alreadySigned , handleDone, setShowMessage}) => {
const type = 'contractMain'
const serverAddress = server + "api2/contractController.php"
const [loading, setLoading] = useState(false)

const [email, setEmail] = useState("")
const [formData, setFormData] = useState({
      employer: data ? data.employer : 'Vaněček Marek, Vítězslava Nezvala 4281, Chomutov 430 01, Ic: 09286543' ,
      employee: data ? data.employee : '',
      startDate: data ? data.startDate : '',
      contractStartDate: data ? data.contractStartDate : '',
      contractEndDate: data ? data.contractEndDate:  '',
      date: data ? data.date: '',
  });

  // Function to handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Odeslat
  const handleSubmit = (e) => {

    e.preventDefault();
    // Convert formData to JSON
    const json = JSON.stringify(formData);
    
    // Pošle data
    if(json && email.length > 5) {
      setLoading(true)
        fetchData(serverAddress , {
            token: token,
            action: 'SAVE',
            type: type,
            formData: formData,
            email: email
        }).then( (res) => {
          setShowMessage('Smlouva byla odeslána.')
          setLoading(false)
     
        })
    } else {
      alert('vyplňte email')
    }
  };



/// Uloží podpis
const sendSignatureToServer = async (dataUrl) => {
  // Concatenate the full URL
  const serverAddress = `${server}api2/saveSignatureController.php`;
  console.log(dataUrl)
  // Send the data to the server
  try {
    const response = await fetch(serverAddress, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: "SAVE_SIGNATURE",
        payload: {
          tokenOfContract: tokenOfContract,
          signature: dataUrl
        }
      }),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const result = await response.json();
    console.log('Signature saved:', result);
    handleDone()
    setLoading(false)
  } catch (error) {
    console.error('Error:', error);
  }
};


  return (
    <div className="agreement" style={{marginTop: 20}}>
      <h2>DOHODA O PRACOVNÍ ČINNOSTI</h2>

      <div className="section">
        <br />
        <strong>Zaměstnavatel:</strong>
        <input type='text' className='niceInput' style={{width: '100%'}} name='employer' value={formData.employer} onChange={handleChange} readOnly={alreadySigned ? true : false} />
      
       
      </div>

      <div className="section">
        <strong>Zaměstnanec:</strong> 
        <input type="text" className='niceInput'  style={{width: '100%'}} name='employee' value={formData.employee} onChange={handleChange} readOnly={alreadySigned ? true : false}/>

      </div>

      <p>uzavírají tuto "Dohodu o pracovní činnosti"</p>

      <ol>
        <li>
          Zaměstanec se zavazuje pro zaměstnavatele na základě této dohody vykonávat následující druh práce : Řidič taxi
          Zaměstnanec bude práci vykonávat osobně.
        </li>
        <li>
          Dnem nástupu do práce je <input type='text' className='niceInput' name='startDate' value={formData.startDate} onChange={handleChange} readOnly={alreadySigned ? true : false}/>
          tato dohoda se sjednává na dobu určitou od <input type='text' className='niceInput' name='contractStartDate' value={formData.contractStartDate} onChange={handleChange} readOnly={alreadySigned ? true : false}/> do <input type='text' className='niceInput' name='contractEndDate' value={formData.contractEndDate} onChange={handleChange} readOnly={alreadySigned ? true : false}/>
          Zaměstnanec bude vykonávat práci v rozsahu maximálních 20 hodin
          s nepravidelnou pracovní dobou.
        </li>
        <li>
          Za řádně vykonanou práci odpovídající sjednaným podmínkám bude Zaměstnanci poskytována odměna ve výši 2.500,- Kč ( slovy: dvatisícepětsetkorunčeských)
          Dnem splatnosti a výplatním termínem odměny je k poslednímu dni v měsíci. Po měsíci, ve kterém vznikl Zaměstnanci nárok na odměnu.
          Odměna bude vyplácena v hotovosti.
        </li>
        <li>
          Zaměstananec je povinen vykonávat svěřenou práci svědomitě a odborně a to podle svých nejlepších schopností a vědomostí.
        </li>
        <li>
          Zaměstnavatel vytvoří Zaměstnanci pracovní podmínky zajišťující řádný bezpečný výkon práce, poskytne mu sjednanou odměnu.
        </li>
        <li>
          Tato dohoda může být zrušena: dohodou smluvních stran : Výpovědí Zaměstnance po dobu 15 dní nebo okamžitým zrušení ze strany Zaměstnavatele
        </li>
        <li>
          Zaměstnanec stvrzuje, že byl před uzavřením této dohody řádně seznámen se svými právy a povinnostmi.
        </li>
        <li>
          Obsah této dohody může být změněn písemnou dohodou obou smluvních stran.
        </li>
        <li>
          Tato dohoda byla sepsána ve dvou vyhotoveních, z nichž jedno obdrží Zaměstnavatel a druhé Zaměstnanec.
        </li>
        <li>
          Na důkaz toho, že je dohoda uzavírána svobodně a vážně, strany vlastnoručně podepisují.
        </li>
      </ol>

      <div className="signatures">
        <p>V Chomutově dne : <input type='text' className='niceInput' name='date' value={formData.date} onChange={handleChange} readOnly={alreadySigned ? true : false} /></p>
        <br />
        <br />
        {alreadySigned && <img src={razitko} style={{width: 300}}/> }
        <p>________________________________</p>
        <p>Zaměstanavatel: Vaněček Marek</p>
        
        <br />  <br />
        {!alreadySigned && tokenOfContract && <SignatureColumn sendSignatureToServer={sendSignatureToServer}/> }
        {alreadySigned && <img src={server +'api2/public/signature/' + tokenOfContract + '.png'}/>}
        <p>Zaměstnanec</p>
      </div>
      <div style={{display:'flex' , justifyContent: 'flex-end'}}>
        { !tokenOfContract &&  <input type='text' className='niceInput' placeholder='email' name='email' value={email} onChange={(e) => setEmail(e.target.value)}/> }
        {!tokenOfContract && !loading && <Button variant="success" onClick={handleSubmit}>Odeslat</Button> }
        {!tokenOfContract && loading && <Button variant="secondary">Odesílám <Spinner animation="border" size='sm'/></Button> }
      </div>
    </div>
  );
}

export default ContractMain;
